<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Transfer Ayar Geçmişi</h3>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->

          <div class="m-portlet m-portlet--mobile">
            <div class="m-portlet__body">
                <div class="row col-lg-12">
                <form class="m-form m-form--fit m-form--label-align-right col-lg-12">
                  <div class="m-portlet__body">
                    <div class="form-group m-form__group row">
                      <div class="col-lg-2">
                        <input
                          type="text"
                          v-model="seachModel.gatewayName"
                          class="form-control m-input"
                          placeholder="Entegrasyon Adı."
                        />
                      </div>
                      <div class="col-lg-2">
                        <select
                          class="form-control m-input"
                          placeholder="Durum."
                          v-model="seachModel.status"
                        >
                          <option value="null">Durum Seçiniz.</option>
                          <option
                            v-for="option in status"
                            v-bind:value="option.id"
                            v-bind:key="option.name"
                          >{{ option.name }}</option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <datepicker
                          type="text"
                          format="dd.MM.yyyy"
                          input-class="form-control"
                          placeholder="Başlangıç Tarihi."
                          v-model="seachModel.startDate"
                        ></datepicker>
                      </div>
                      <div class="col-lg-3">
                        <datepicker
                          type="text"
                          format="dd.MM.yyyy"
                          input-class="form-control"
                          placeholder="Bitiş Tarihi."
                          v-model="seachModel.endDate"
                        ></datepicker>
                      </div>
                       <div class="col-lg-1">
                          <button
                            type="button"
                            @click="search()"
                            class="srcbtn"
                          >Ara</button>
                        </div>
                    </div>
                  </div>
                </form>
              </div>
              <!--begin: Datatable -->
              <div id="m_table_1_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                <div class="row"></div>
                <div class="row">
                  <div class="col-sm-12">
                    <table
                      class="table table-striped- table-bordered table-hover table-checkable dataTable no-footer dtr-inline"
                      id="m_table_1"
                      role="grid"
                      aria-describedby="m_table_1_info"
                      style="width: 1457px;"
                    >
                      <thead>
                        <tr role="row">
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 57.5px;"
                            aria-label="Order ID: activate to sort column ascending"
                          >Transfer</th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 57.5px;"
                            aria-label="Order ID: activate to sort column ascending"
                          >Entegrasyon</th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px;"
                            aria-label="Country: activate to sort column ascending"
                          >Durum</th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px;"
                            aria-label="Country: activate to sort column ascending"
                          >Başlangıç Tarihi</th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px;"
                            aria-label="Country: activate to sort column ascending"
                          >Bitiş Tarihi</th>
                             <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 99.5px;"
                            aria-label="Country: activate to sort column ascending"
                          >Mesaj</th>
           
                        </tr>
                      </thead>
                      <tbody v-if="model.items && model.items.length">
                        <tr role="row" class="odd" v-for="item in model.items" v-bind:key="item.id">
                          <td>{{item.transferConfiguration.name}}</td>
                          <td>{{item.transferConfiguration.gatewayName}}</td>
                          <td>{{item.statusDescription}}</td>
                          <td>{{item.taskExecutionStartDate}}</td>
                          <td>{{item.taskExecutionEndDate}}</td>
                          <td>{{item.message}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--end::Portlet-->
             <div class="m-portlet m-portlet--mobile">
               <paginate
              :page-count="Math.ceil(this.model.totalCount/this.model.pageSize)"
              :click-handler="changePage"
              :prev-text="'<<'"
              :next-text="'>>'"
              :container-class="'pagination'"
              :page-class="'pageclass'"
              :next-link-class="'pageclass'"
              :prev-link-class="'pageclass'"
              :active-class="'activelink'"
   >

  >
            </paginate>

             </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css">
.pagination {
  color: black;
  float: left;
  padding: 8px 8px;
  text-decoration: none;  
}

.pageclass{
   color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  border: 1px solid #ddd;
}
.activelink{
  background-color: turquoise;
  border:1px;
}

.srcbtn{
    background-color: #3e7bf5; 
    border: none;
    border-radius:5px;
    font-weight: bold;
    color: white;
    padding:8px 30px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
  }
  .srcbtn:hover{
    background-color: red;
  }

</style>

<script>
import { _searchTransferConfigurationHistory,_getTransferStatus } from "../../services/GatewayService";
import datepicker from "vuejs-datepicker";

export default {
  data() {
    return {
      model:{
        items: [],
        page:0,
        pageSize:0,
        totalCount:0
      },
            seachModel: {
        gatewayName: null,
        status: null,
        startDate: null,
        endDate: null,
        transferMessage: null,
        page: null
      },
      status: [],
      
    };
  },
  created() {
    this.getAll();
    this.getStatus();
  },
    components: {
    datepicker: datepicker
  },
  methods: {
    getAll: function() {
      // let loader=this.$loading.show();
      _searchTransferConfigurationHistory(this.seachModel).then(response => {
        this.model = response.data.data;
      });
    },
        changePage: function(page) {
      this.seachModel.page = page;
      this.getAll();
    },
    getStatus: function() {
      _getTransferStatus().then(response => {
        this.status = response.data;
      });
    },
        search: function() {
           this.seachModel.page=1;
      this.getAll(this.seachModel);
    },
  }
};
</script>